import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../style/theme';

import HeroBackground from '../../UI/Img/Hero/index';
import LowerHexagons from "./LowerHexagons";
import UpperHexagos from "./UpperHexagos";

const StyledHero = styled.section`
  ${(props) => {
  const { minHeight } = props;
    return css`
      margin-top: 0;
      background: #8c8c8c;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: ${minHeight};
    `;
  }}
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  > img {
    object-fit: cover;
    margin: 0;
    height: 100%;
    width: 100%;
  };
`;

export class Hero extends React.Component {
  state = { minHeight: '100vh'}
  componentDidMount = () => {
    this.setState({
      minHeight: `${window.innerHeight}px` || '100vh',
    })
  }
  render() {
    const props = this.props
    return (
      <StyledHero minHeight={this.state.minHeight}>
        <UpperHexagos/>
        <LowerHexagons/>
        <ImageWrapper>
          <img
            src={HeroBackground("big")}
            srcSet= {HeroBackground("small") + " 450w," +
              HeroBackground("medium") + " 960w," +
              HeroBackground("big") + " 1500w"
            }
            sizes="(max-width: 552px) 450px, (max-width: 1062px) 960px, 1500px"
            alt="hero"
          />
        </ImageWrapper>
      </StyledHero>
    );
  }
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Index/Hero/index.jsx